<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div v-if="canRender">
      <CadastroRotas :copy="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import rotasStore from '../_store'

import CadastroRotas from './CadastroRotas'

export default {
  name: 'CopiarRota',
  props: {
    _id: String,
  },
  components: { CadastroRotas, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('copiarRotaModulePABXStore', ['getRotaSelecionada']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'copiarRotaModulePABXStore', rotasStore)

    await this.selecionarRota(this._id)
    this.description = this.getRotaSelecionada.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('copiarRotaModulePABXStore', ['selecionarRota']),
  },
}
</script>